import { render, staticRenderFns } from "./HomeSliderInfo.vue?vue&type=template&id=bc16131c&scoped=true"
import script from "./HomeSliderInfo.vue?vue&type=script&lang=js"
export * from "./HomeSliderInfo.vue?vue&type=script&lang=js"
import style0 from "./HomeSliderInfo.vue?vue&type=style&index=0&id=bc16131c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc16131c",
  null
  
)

export default component.exports